import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { MainModal } from '..';
import { Button, Center, LinkGray, Title } from '../styled';
import { Period, createPrice } from '../../helpers/product';
import { modalActions } from '../../store/ducks/modal';
import { appActions } from '../../store/ducks/app';

const mapStateToProps = (state: any) => ({
  confirmAutoRenewalModal: state.modalData.confirmAutoRenewalModal,
  prescription: state.appData.prescription,
  products: state.appData.general.products,
  selectedPeriod: state.appData.general.selectedPeriod,
  currency: state.appData.currency,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  toggleConfirmAutoRenewalModal: (isOpen: boolean) => void;
  toggleInputCardDetailsModal: (isOpen: boolean) => void;
  enableSubscription: () => void;
}
type Props = StateProps & DispatchProps;

class ConfirmAutoRenewalModal extends React.Component<Props> {
  handleClose = (_event: any) => {
    this.props.toggleConfirmAutoRenewalModal(false);
  }

  render() {
    const { prescription, products, selectedPeriod } = this.props;
    return (
      <MainModal contentLabel="Confirm auto renewal"
        isOpen={this.props.confirmAutoRenewalModal} close={this.handleClose} >
        <Title>
          <FormattedMessage id={`switch_to_${selectedPeriod}_billing`} />
        </Title>
        <br />
        <small>
          <FormattedMessage
            id={`enable_auto_renewal_description_${selectedPeriod}_${prescription.type}`}
            values={
              {
                $1: createPrice(products, prescription.type, Period.YEARLY, this.props.currency),
                $2: createPrice(products, prescription.type, Period.YEARLY, this.props.currency, true),
                $3: createPrice(products, prescription.type, Period.MONTHLY, this.props.currency),
              }
            }
          />
        </small>
        <br />
        <Center>
          <Button onClick={this.props.enableSubscription}><FormattedMessage id="confirm" /></Button>
        </Center>
        <br />
        <Center>
          <LinkGray onClick={this.handleClose}><FormattedMessage id="no_thanks" /></LinkGray>
        </Center>
      </MainModal>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, { ...appActions, ...modalActions })(ConfirmAutoRenewalModal);
